var map = {
	"./call.svg": 3007,
	"./email.svg": 3008,
	"./food.svg": 3009,
	"./house.svg": 3010,
	"./people.svg": 3011,
	"./task.svg": 3012,
	"./whatsapp.svg": 3013
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 627;